import { EventApis } from '../../../API/Event/EventApi'
import ErrorHandle from '../../../Components/ErrorHandle'
import { CONSTANT } from '../../../Constants/EventService'

export const clickedOnSaveButton = (reqObj, SetIsSaveLoading, setToasts) => {
  SetIsSaveLoading(true)
  EventApis.eventSelectSaveEventId(reqObj)
    .then((res) => {
      let item = [
        {
          name: CONSTANT?.SAVE_EVENT?.Success?.message,
          type: CONSTANT?.SAVE_EVENT?.Success?.type,
        },
      ]
      setToasts(item)
      setTimeout(() => {
        setToasts(null)
      }, 3000)
    })
    .catch((err) => {
      console.error('Error for eventSelectSaveEventId', err)
      let customMessage = CONSTANT?.SAVE_EVENT?.Error?.message
      let type = CONSTANT?.SAVE_EVENT?.Error?.type
      let color = CONSTANT?.SAVE_EVENT?.Error?.color
      ErrorHandle(err, setToasts, customMessage, type, color)
    })
    .finally(() => {
      SetIsSaveLoading(false)
    })
}
export const clickedOnNotSaveButton = (reqObj, SetIsSaveLoading, setToasts, callBack) => {
  SetIsSaveLoading(true);
  EventApis.eventSelectUnsavedEventId(reqObj)
    .then((res) => {
      let item = [
        {
          name: CONSTANT?.UNSAVE_EVENT?.Success?.message,
          type: CONSTANT?.UNSAVE_EVENT?.Success?.type,
        },
      ]
      setToasts(item)
      callBack()
      setTimeout(() => {
        setToasts(null)
      }, 3000)
    })
    .catch((err) => {
      console.error('Error for eventSelectUnsavedEventId', err)

      let customMessage = CONSTANT?.UNSAVE_EVENT?.Error?.message
      let type = CONSTANT?.UNSAVE_EVENT?.Error?.type
      let color = CONSTANT?.UNSAVE_EVENT?.Error?.color
      ErrorHandle(err, setToasts, customMessage, type, color)
    })
    .finally(() => {
      SetIsSaveLoading(false)
    })
}
export const clickedOnGoingButton = (reqObj, SetIsGoingLoading, setToasts) => {
  SetIsGoingLoading(true);
  EventApis.setGoingForAnEventForUser(reqObj)
    .then((res) => {
      let item = [
        {
          name: CONSTANT?.ON_GOING_EVENT?.Success?.message,
          type: CONSTANT?.ON_GOING_EVENT?.Success?.type,
        },
      ]
      setToasts(item)
      setTimeout(() => {
        setToasts(null)
      }, 3000)
    })
    .catch((err) => {
      console.error('Error for loadAllSuggestedEventsForLoggedInUser', err)

      console.error('Error in remove post', err)
      let customMessage = CONSTANT?.ON_GOING_EVENT?.Error?.message
      let type = CONSTANT?.ON_GOING_EVENT?.Error?.type
      let color = CONSTANT?.ON_GOING_EVENT?.Error?.color
      ErrorHandle(err, setToasts, customMessage, type, color)
    })
    .finally(() => {
      SetIsGoingLoading(false)
    })
}
export const clickedOnNotGoingButton = (reqObj, SetIsGoingLoading, setToasts, callBack) => {
  SetIsGoingLoading(true);
  EventApis.setNotGoingForAnEventForUser(reqObj)
    .then((res) => {
      let item = [
        {
          name: CONSTANT?.ON_NOT_GOING_EVENT?.Success?.message,
          type: CONSTANT?.ON_NOT_GOING_EVENT?.Success?.type,
        },
      ]
      setToasts(item)
      callBack()
      setTimeout(() => {
        setToasts(null)
      }, 3000)
    })
    .catch((err) => {
      console.error('Error for loadAllSuggestedEventsForLoggedInUser', err)

      let customMessage = CONSTANT?.ON_NOT_GOING_EVENT?.Error?.message
      let type = CONSTANT?.ON_NOT_GOING_EVENT?.Error?.type
      let color = CONSTANT?.ON_NOT_GOING_EVENT?.Error?.color
      ErrorHandle(err, setToasts, customMessage, type, color)
    })
    .finally(() => {
      SetIsGoingLoading(false);
    })
}
export const clickedOnInterestedButton = (reqObj, SetIsInterestedLoading, setToasts) => {
  SetIsInterestedLoading(true);
  EventApis.eventSelectInterestedEventId(reqObj)
    .then((res) => {
      let item = [
        {
          name: CONSTANT?.ON_INTERESTED_EVENT?.Success?.message,
          type: CONSTANT?.ON_INTERESTED_EVENT?.Success?.type,
        },
      ]
      setToasts(item)
      setTimeout(() => {
        setToasts(null)
      }, 3000)
    })
    .catch((err) => {
      console.error('Error for eventSelectInterestedEventId', err)

      let customMessage = CONSTANT?.ON_INTERESTED_EVENT?.Error?.message
      let type = CONSTANT?.ON_INTERESTED_EVENT?.Error?.type
      let color = CONSTANT?.ON_INTERESTED_EVENT?.Error?.color
      ErrorHandle(err, setToasts, customMessage, type, color)
    })
    .finally(() => {
      SetIsInterestedLoading(false)
    })
}
export const clickedOnNotInterestedButton = (reqObj, SetIsInterestedLoading, setToasts, callBack) => {
  SetIsInterestedLoading(true);
  EventApis.eventSelectNotinterestedEventId(reqObj)
    .then((res) => {
      let item = [
        {
          name: CONSTANT?.ON_NOT_INTERESTED_EVENT?.Success?.message,
          type: CONSTANT?.ON_NOT_INTERESTED_EVENT?.Success?.type,
        },
      ]
      setToasts(item)
      callBack()
      setTimeout(() => {
        setToasts(null)
      }, 3000)
    })
    .catch((err) => {
      console.error('Error for eventSelectNotinterestedEventId', err)

      let customMessage = CONSTANT?.ON_NOT_INTERESTED_EVENT?.Error?.message
      let type = CONSTANT?.ON_NOT_INTERESTED_EVENT?.Error?.type
      let color = CONSTANT?.ON_NOT_INTERESTED_EVENT?.Error?.color
      ErrorHandle(err, setToasts, customMessage, type, color)
    })
    .finally(() => {
      SetIsInterestedLoading(false);
    })
}
export const handleDeletePost = (reqObj, SetIsDeleteLoading, setToasts, callBack) => {
  SetIsDeleteLoading(true);
  EventApis.cancelEventByUsingEventId(reqObj)
    .then((res) => {
      let item = [
        {
          name: CONSTANT?.DELETE_EVENT?.Success?.message,
          type: CONSTANT?.DELETE_EVENT?.Success?.type,
        },
      ]
      setToasts(item)
      callBack()
      setTimeout(() => {
        setToasts(null)
      }, 3000)
    })
    .catch((err) => {
      let customMessage = CONSTANT?.DELETE_EVENT?.Error?.message
      let type = CONSTANT?.DELETE_EVENT?.Error?.type
      let color = CONSTANT?.DELETE_EVENT?.Error?.color
      ErrorHandle(err, setToasts, customMessage, type, color)
    })
    .finally(() => {
      SetIsDeleteLoading(false)
    })
}
